// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"496":"graphql-print","557":"f10664bc"}[chunkId] || chunkId) + "." + {"46":"83801b61a4071302","496":"83edc8afc0370428","505":"8b0ee259dd38aacd","557":"1efa5216adf15a0f"}[chunkId] + ".js";
};